'use client';

export { useTheme } from '@/components/theme-provider';
